import { render, staticRenderFns } from "./DeveloperSelection.vue?vue&type=template&id=b3d13a06&scoped=true"
import script from "./DeveloperSelection.vue?vue&type=script&lang=js"
export * from "./DeveloperSelection.vue?vue&type=script&lang=js"
import style0 from "./DeveloperSelection.vue?vue&type=style&index=0&id=b3d13a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d13a06",
  null
  
)

export default component.exports